module.exports = __webpack_public_path__ + "static/profile-5499b5475ad63f6f6e78baa457e2fbd2.png";